import React from "react";
import "./HomePage.css";

interface HomePageProps {
  onSelectGame: (gameId: string) => void;
}

async function forceAppRefresh() {
  try {
    await fetch(window.location.origin + "/", { method: "HEAD", cache: "no-store" });
  } catch {
    alert("Sem ligação à internet. Ligue-se e tente novamente.");
    return;
  }

  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }
  } finally {
    window.location.replace(window.location.origin + "/");
  }
}

const HomePage: React.FC<HomePageProps> = ({ onSelectGame }) => {
  const games = [
    {
      id: "labirinto-equilibrio",
      name: "Labirinto do Equilíbrio",
      description: "Guie o produto até à meta sem tocar nas paredes.",
    },
    {
      id: "escolhe-bem",
      name: "Escolhe Bem",
      description: "Apanhe os produtos certos e atinja a pontuação alvo.",
    },
    {
      id: "plinko",
      name: "Plinko",
      description: "Lança bolas e ganha prémios!",
    },
    {
      id: "quiz",
      name: "Quiz Palex",
      description: "Responda às perguntas e suba na classificação.",
    },
    {
      id: "puzzle",
      name: "Sliding Puzzle",
      description: "Resolve o bordado albicastrense o mais depressa possível.",
    },
    {
      id: "health-rush",
      name: "Health Rush",
      description: "Toca nas máquinas Affidea e evita os vírus.",
    },
  ];

  return (
    <div className="home-page">
      <button
        type="button"
        className="home-refresh-button"
        onClick={forceAppRefresh}
        aria-label="Atualizar aplicação">
        ↻
      </button>
      <div className="home-container">
        <h1 className="home-title">PlayKit</h1>
        <p className="home-subtitle">Escolha o seu jogo</p>

        <div className="games-grid">
          {games.map((game) => (
            <button
              key={game.id}
              className="game-card"
              onClick={() => onSelectGame(game.id)}>
              <div className="game-card-content">
                <h2 className="game-card-title">{game.name}</h2>
                <p className="game-card-description">{game.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
